import DiagramWithToggleKey from "../shared/DiagramWithToggleKey";
import EndocrineOverviewCombined from "./index";

const EndocrineOverviewWithToggleKey = props => (
  <DiagramWithToggleKey
    CombinedDiagram={EndocrineOverviewCombined}
    keyControlsId="endocrine-overview-key"
    {...props}
  />
);

export default EndocrineOverviewWithToggleKey;
